import { Popover } from "antd";
import { QuestionCircleOutlined } from "@ant-design/icons";
import "./avisos.css";

export const AyudaContextual = ({ children, label = "Ver nota importante" }) => {
  const contenido = (
    <div className="ayuda-contextual__contenido">
      <strong className="ayuda-contextual__titulo">Nota importante</strong>
      {children}
    </div>
  );

  return (
    <Popover content={contenido} trigger={["hover", "focus"]} placement="top" mouseEnterDelay={0.15}>
      <button type="button" className="ayuda-contextual__boton" aria-label={label}><QuestionCircleOutlined /></button>
    </Popover>
  );
};
